const initialState = 0;

const ReservationChildSubTabReducer = (state = initialState, action) => {
  switch (action.type) {
    case "setreservationChildSubTab":
      state = action.payload;
      return state;
    default:
      return state;
  }
};

export default ReservationChildSubTabReducer;
